import React from 'react';
import PropTypes from 'prop-types';
import TooltipComponent from "../components/Tooltip";
import uuid from "react-native-uuid";

const Tooltip = props => {
  const [idTooltip, setIdTooltip] = React.useState('x' + uuid.v4());

  return (
    <React.Fragment>
      {React.cloneElement( props.children, { id: idTooltip } )}
      <TooltipComponent {...props} className={`tooltip-on-modal`} id={idTooltip} />
    </React.Fragment>
  );
};

Tooltip.propTypes = {
  children: PropTypes.element.isRequired,
  msg: PropTypes.string.isRequired,
};

export default Tooltip;
